import { render } from "./TaskCreateNewTask.vue?vue&type=template&id=9f67ac28"
import script from "./TaskCreateNewTask.vue?vue&type=script&lang=js"
export * from "./TaskCreateNewTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__